import { Provider } from '@angular/core';
import { TL_FUEL_URL } from '@dat/iq-trendlines-fuel';
import { TL_GRAPH_LT_URL } from '@dat/iq-trendlines-graph-lt';
import { TL_NTL_LT_URL } from '@dat/iq-trendlines-graph-lt-ntl';
import { TL_GRAPH_RATES_URL } from '@dat/iq-trendlines-graph-rates';
import { TL_GRAPH_RATES_NATIONAL_URL } from '@dat/iq-trendlines-graph-rates-ntl';
import { TL_MAP_LT_URL, TL_REGIONAL_RATES_URL } from '@dat/iq-trendlines-map';
import { TL_NTL_SPOT_URL } from '@dat/iq-trendlines-ntl-spot';
import { TL_SNAPSHOT_URL } from '@dat/iq-trendlines-snapshot';

const ANALYTICS_BASE_URL = 'https://analytics.api.nprod.dat.com';
export const PARENT_ORIGIN = 'http://localhost:4200';

export const URLS: Provider = [
    {
        provide: TL_FUEL_URL,
        useValue: '/v2/trendlines/fuel',
    },
    {
        provide: TL_NTL_SPOT_URL,
        useValue: '/v2/trendlines/nationalHistory',
    },
    {
        provide: TL_GRAPH_LT_URL,
        useValue: '/v2/trendlines/%s/loadAndTruckRatio',
    },
    {
        provide: TL_GRAPH_RATES_URL,
        useValue: '/v2/trendlines/nationalHistory',
    },
    {
        provide: TL_MAP_LT_URL,
        useValue: '/v2/trendlines/lt/%s',
    },
    {
        provide: TL_GRAPH_RATES_NATIONAL_URL,
        useValue: '/v2/trendlines/nationalHistory',
    },
    {
        provide: TL_NTL_LT_URL,
        useValue: '/v2/trendlines/%s/loadAndTruckRatio',
    },
    {
        provide: TL_REGIONAL_RATES_URL,
        useValue: '/v2/trendlines/%s/regionalRates',
    },
    {
        provide: TL_SNAPSHOT_URL,
        useValue: '/v2/trendlines/trends',
    },
];
